import Immutable from 'immutable'

export const SslRecord = Immutable.Record({
  domain: null,
}, 'ServiceSsl')

export default function createServiceSsl(data) {
  return new SslRecord(data)
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Service/Ssl.js